<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M3.74967 13.75C2.49967 14.8 2.08301 17.9167 2.08301 17.9167C2.08301 17.9167 5.19967 17.5 6.24967 16.25C6.84134 15.55 6.83301 14.475 6.17467 13.825C5.85076 13.5158 5.42409 13.3372 4.97653 13.3234C4.52897 13.3095 4.09207 13.4614 3.74967 13.75Z"
			:fill="computedFill"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M10 12.5L7.5 10C7.94345 8.84953 8.50184 7.74673 9.16667 6.70834C10.1377 5.15583 11.4897 3.87755 13.0942 2.99508C14.6986 2.11262 16.5022 1.65531 18.3333 1.66667C18.3333 3.93334 17.6833 7.91667 13.3333 10.8333C12.2807 11.4989 11.164 12.0573 10 12.5Z"
			:fill="computedFill"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M7.49967 10H3.33301C3.33301 10 3.79134 7.475 4.99967 6.66667C6.34967 5.76667 9.16634 6.66667 9.16634 6.66667"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M10 12.5V16.6667C10 16.6667 12.525 16.2083 13.3333 15C14.2333 13.65 13.3333 10.8333 13.3333 10.8333"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconInitiator',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: '#D43949'
		},
		filled: {
			type: Boolean,
			default: false
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.3
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
